
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditAviamento from '../EditAviamento'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListAviamentoRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditAviamento, setModalEditAviamento] = useState(false)
    const [aviamentoId, setAviamentoId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [aviamentoName, setAviamentoName] = useState("")
    const [selectedItens, setSelectedItens] = useState(selectedData || [])

    async function deleteAviamento(id) {
        let msgType = 'success'
        const data = await api.delete(`/aviamento/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        setSelectedItens(next)
        handleOnSelectItem(next)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                selectItem ? (
                    <div key={item._id} className={`pg-item pg-item-selectable ${isSelected(item) ? 'pg-item-selected' : ''}`} onClick={() => select(item)}>
                        <div className='pg-item-main'>
                            <div className='pg-item-header'>
                                <span className='pg-item-name'>{item.name}</span>
                                <span className='pg-item-name'>{item.unit?.label || item.unit?.value}</span>
                            </div>
                        </div>
                        <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                            <FiCheck size={14} />
                        </div>
                    </div>
                ) : (
                    <div key={item._id} className='pg-item'>
                        <div className='pg-item-main'>
                            <div className='pg-item-header'>
                                <span className='pg-item-name'>{item.name}</span>
                                <span className='pg-item-name'>{item.unit?.label || item.unit?.value}</span>
                            </div>
                        </div>

                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setAviamentoId(item._id); setModalEditAviamento(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setAviamentoId(item._id); setAviamentoName(item.name) }} />
                            }
                        </div>
                    </div>
                )
            ))
        }
    }

    return (
        <div>
            {listArray()}

            {!selectItem && (
                <>
                    <Modal
                        modalStatus={modalEditAviamento}
                        changeStatus={setModalEditAviamento}
                        w={82}
                        content={
                            <EditAviamento id={aviamentoId} handleOnSuccess={() => { setModalEditAviamento(false); handleOnSuccess() }} btCancelAction={() => setModalEditAviamento(false)} />
                        }
                    />

                    <ConfirmDeleteModal
                        modalStatus={modalDeleteItem}
                        changeStatus={setModalDeleteItem}
                        onConfirm={() => deleteAviamento(aviamentoId)}
                        message="Deseja realmente excluir esse aviamento?"
                        itemName={aviamentoName}
                    />
                </>
            )}

        </div>
    )
}

export default ListAviamentoRow
